enum EntityFilterRule {
    TextEquals = 101,
    TextContains = 102,
    TextEmpty = 103,
    TextNotEmpty = 104,
    TextareaEquals = 201,
    TextareaContains = 202,
    TextareaEmpty = 203,
    TextareaNotEmpty = 204,
    EmailEquals = 251,
    EmailContains = 252,
    EmailEmpty = 253,
    EmailNotEmpty = 254,
    NumberEquals = 301,
    NumberBetween = 302,
    NumberMore = 303,
    NumberLess = 304,
    NumberEmpty = 305,
    DatetimeEquals = 401,
    DatetimeBetween = 402,
    DatetimeAfter = 403,
    DatetimeBefore = 404,
    DatetimeEmpty = 405,
    LogicalEquals = 501,
    LinkedEquals = 601,
    LinkedHasValue = 602,
    LinkedNoValue = 603,
    FormulaEquals = 701,
    FormulaBetween = 702,
    FormulaMore = 703,
    FormulaLess = 704,
    FormulaNA = 705
}

export default EntityFilterRule;